import React, { useState, useEffect, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Badge, Card, Checkbox, CircularProgress, Select, MenuItem } from '@mui/material';
import crudsService from 'services/cruds-service';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MDBox from 'components/MDBox';
import Footer from 'examples/Footer';
import MDButton from 'components/MDButton';
import moment from 'moment/moment';
import MDInput from 'components/MDInput';
import MDModal from 'components/MDModel';
import MDTypography from 'components/MDTypography';
import { useMediaQuery } from 'react-responsive';
import { JSONTree } from 'react-json-tree';
import { JSONTreeTheme } from 'utils/constant';
import { useMaterialUIController } from 'context';
import { toast } from 'react-toastify';
import { useWebSocket } from 'context/WebSocketContext';

function RivioWebHookManagement() {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [sortModel, setSortModel] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [rowCount, setRowCount] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paramTableData, setParamTableData] = useState();
    const [openViewModal, setOpenViewModal] = useState(false);
    const [modalData, setModalData] = useState();
    const [format, setFormat] = useState(false);
    const [expand, setExpand] = useState(false);
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
    const [controller] = useMaterialUIController();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([])
    const [isInit, setInit] = useState(false)
    // const { assetTrackerData } = useWebSocket();
    // keep a ref for AbortController
    const abortControllerRef = useRef(null);

    const { darkMode } = controller;

    const fetchData = async () => {

        // cancel any ongoing request before making a new one
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        if(!isInit){
            return
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;
        setLoading(true);
        try {
            const sortField = sortModel[0]?.field || "created_at";
            const sortOrder = sortModel[0]?.sort || "DESC";

            const response = await crudsService.getRivioWebHookLogs({
                page: paginationModel.page + 1,
                pageSize: paginationModel.pageSize,
                sortField,
                sortOrder,
                search: searchQuery,
                ...(selectedStatuses.length > 0 ? {status_type_id: selectedStatuses} : {})
            }, controller.signal);
            if (response.success) {
                setRowCount(response.count);
                setTableData(getRows(response.data));
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDataWithoutSignal = async () => {

        setLoading(true);
        try {
            const sortField = sortModel[0]?.field || "created_at";
            const sortOrder = sortModel[0]?.sort || "DESC";
            const response = await crudsService.getRivioWebHookLogs({
                page: paginationModel.page + 1,
                pageSize: paginationModel.pageSize,
                sortField,
                sortOrder,
                search: searchQuery
            });
            if (response.success) {
                setRowCount(response.count);
                setTableData(getRows(response.data));
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
            setInit(true)
        }
    };

    useEffect(() => {
        fetchDataWithoutSignal()
    }, [])

    // useEffect(() => {
    //     if (searchQuery == assetTrackerData?.ident) {
    //         fetchData();
    //     }

    //     if(searchQuery !== '') {
    //         return
    //     }

    //     let debounceTimer = null;

    //     if (assetTrackerData) {
    //         debounceTimer = setTimeout(() => {
    //             fetchData();
    //         }, 3000); // 3000ms debounce
    //     }

    //     return () => {
    //         if (debounceTimer) {
    //             clearTimeout(debounceTimer);
    //         }
    //         // abort when unmounting
    //         if (abortControllerRef.current) {
    //             abortControllerRef.current.abort();
    //         }
    //     }
    // }, [assetTrackerData]);

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            fetchData();
        }, 500); // 500ms debounce

        return () => clearTimeout(debounceTimer);
    }, [paginationModel, sortModel, searchQuery, selectedStatuses])

    const handleIdentifier = (value) => {
        let v = "-";
        let { event = null, dynamodb = null } = value;

        // Level monitor
        if (event && event?.Records && event?.Records.length) {
            v = event?.Records[0]?.dynamodb?.NewImage?.id?.S ?? "-";
            return v
        }
        // For Gateway Device
        if(dynamodb && dynamodb?.Keys?.id){
            v = dynamodb?.Keys?.id?.S ?? '-'
            return v
        }
        // For GPS Identi
        if (value && value?.length) {
            v = value[0]?.ident ?? "-";
            return v
        }
        return v;
    };

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row.id,
                device_id: row.device_id,
                service: row.webhookType?.value,
                status: row.statusType.status_name,
                created_at: row.created_at,
                error_msg: row.error_msg,
                // identifier: handleIdentifier(row.value?.length ? row.value : row.value?.event),
                identifier: handleIdentifier(row.value),
                ...row,
            };
        });
        return updatedInfo;
    };

    const clickViewHandler = (e, id, value) => {
        e.stopPropagation();
        setOpenViewModal(true);
        setModalData({
            identifier: value?.identifier,
            status: value?.status,
            service: value?.service,
            error: value?.error,
        });
        setParamTableData(value.value);
    };

    const handleViewClose = () => {
        setOpenViewModal(false);
    };

    const removeEvents = async (e) => {
        try {
            if (!confirm("Are you sure you want to delete this logs?")) {
                e.nativeEvent.stopImmediatePropagation();
            } else {
                await crudsService.delRivioWebHookLogs(selectedRows);
                fetchData();
                toast.success("The Logs successfully removed");
                setSelectedRows([]);
            }
        } catch (error) {
            console.error(error);
            if (error.hasOwnProperty("errors")) {
                // setNotification({
                //   value: true,
                //   text: error,
                // })
                toast.error("error");
            }
            return null;
        }
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 120 },
        { field: 'device_id', headerName: 'Device id', width: 120 },
        { field: 'service', headerName: 'Service', width: 200 },
        {
            field: 'status', headerName: 'Status', width: 200, renderCell: (params, row) => {
                return (
                    <Badge
                        color={params.value == "Complete" ? "success" : "info"}
                        // variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={params.value}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                );
            }
        },
        { field: 'identifier', headerName: 'Identifier', width: 200 },
        { field: 'error_msg', headerName: 'Error', width: 400 },
        {
            headerName: "Event Date",
            field: "created_at",
            width: 300,
            renderCell: (info) => {
                return (
                    <div
                        style={{
                            whiteSpace: "normal",
                            maxWidth: "300px",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                        }}
                    >
                        {moment(info.value).format("MMMM DD, YYYY h:mm:ss A")}
                    </div>
                );
            },
        },
        {
            headerName: "Target",
            field: "",
            width: 200,
            sortable: false,
            renderCell: (info) => {
                return (
                    <div>
                        <MDButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            type="submit"
                            onClick={(e) => clickViewHandler(e, info.id, info.row)}
                        >
                            View
                        </MDButton>
                    </div>
                );
            },
        },
    ];

    const styles = {
        table: {
            padding: 0,
            borderSpacing: 0,
            borderCollapse: "collapse",
        },
        cell: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: isTabletOrMobile ? "0" : "15px",
            paddingRight: isTabletOrMobile ? "0" : "15px",
        },
        cell1: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: isTabletOrMobile ? "0" : "5px",
            paddingRight: isTabletOrMobile ? "0" : "5px",
            // width: isTabletOrMobile ? '135px' : '165px'
        },
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={1}>
                <MDBox>
                    <Card sx={{ height: 'calc(100vh - 140px)', color: '#fff' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                            <div>Webhook Management</div>
                            <div style={{ display: 'flex', gap: '10px' }} >
                                {
                                    selectedRows.length ?
                                        <MDBox width="5rem" ml="auto">
                                            <MDButton
                                                size="small"
                                                variant="gradient"
                                                color="error"
                                                fullWidth
                                                onClick={() => (!loading ? removeEvents() : {})}
                                                style={{ backgroundColor: "darkred" }}
                                            >
                                                Delete
                                            </MDButton>
                                        </MDBox> : <></>
                                }
                                <MDBox width="8rem" ml="auto">
                                    <Select
                                        multiple
                                        value={selectedStatuses}
                                        onChange={(e) => setSelectedStatuses(e.target.value)}
                                        displayEmpty
                                        fullWidth
                                        size="small"
                                        sx={{ height: '30px' }}
                                        style={{ backgroundColor: selectedStatuses.length > 0 ? "#1A73E8" : "#000", color: 'white' }}
                                        renderValue={(selected) => {
                                            if (selected.length === 0) return 'Status';
                                            return selected.map(id => {
                                                if (id === 49) return 'Created';
                                                if (id === 54) return 'Complete';
                                                if (id === 75) return 'Error';
                                            }).join(', ');
                                        }}
                                    >
                                        <MenuItem value={49}>Created</MenuItem>
                                        <MenuItem value={54}>Complete</MenuItem>
                                        <MenuItem value={75}>Error</MenuItem>
                                    </Select>
                                </MDBox>
                                <MDBox width="5rem" ml="auto">
                                    <MDButton
                                        size="small"
                                        variant="gradient"
                                        // color="primary"
                                        fullWidth
                                        onClick={() => (!loading ? fetchData() : {})}
                                        style={{ backgroundColor: "#1A73E8" }}
                                    >
                                        Refresh
                                    </MDButton>
                                </MDBox>
                                <MDBox width="12rem" ml="auto">
                                    <MDInput
                                        placeholder="Search..."
                                        value={searchQuery}
                                        size="small"
                                        fullWidth
                                        onChange={({ currentTarget }) => {
                                            // setPaginationModel({ ...paginationModel, page: 0 }); // Reset to first page on search
                                            setSearchQuery(currentTarget.value);
                                        }}
                                    />
                                </MDBox>
                            </div>
                        </div>
                        <DataGrid
                            rows={tableData}
                            columns={columns}
                            disableColumnFilter
                            pagination
                            paginationMode="server"
                            sortingMode="server"
                            rowCount={rowCount}
                            paginationModel={paginationModel}
                            pageSizeOptions={[25, 50, 100, 200]} // ✅ Add this
                            onSortModelChange={(model) => setSortModel(model)}
                            onRowSelectionModelChange={(e) => setSelectedRows(e)}
                            onPaginationModelChange={(newPage) => setPaginationModel(newPage)}
                            loading={loading}
                            checkboxSelection
                            disableSelectionOnClick
                            sx={{ color: '#fff' }}
                        />

                    </Card>
                </MDBox>
            </MDBox>
            <MDModal open={openViewModal} onClose={handleViewClose}>
                <div
                    style={{
                        display: isTabletOrMobile ? "block" : "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <div className="table-responsive">
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
                                        <MDTypography fontSize={1}>
                                            <span style={{ fontWeight: "700" }}>Identifier:</span>
                                        </MDTypography>
                                    </th>
                                    <td style={styles.cell}>
                                        <MDTypography fontSize={1}>{modalData?.identifier ?? ""}</MDTypography>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
                                        <MDTypography fontSize={1}>
                                            <span style={{ fontWeight: "700" }}>Service:</span>
                                        </MDTypography>
                                    </th>
                                    <td style={styles.cell}>
                                        <MDTypography fontSize={1}>{modalData?.service ?? ""}</MDTypography>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
                                        <MDTypography fontSize={1}>
                                            <span style={{ fontWeight: "700" }}>Status:</span>
                                        </MDTypography>
                                    </th>
                                    <td style={styles.cell}>
                                        <MDTypography fontSize={1}>
                                            {modalData?.status == "Complete" ? modalData?.status : `${modalData?.status} - ${modalData?.error ?? ""}`}
                                        </MDTypography>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
                                        <MDTypography fontSize={1}>
                                            <span style={{ fontWeight: "700" }}>
                                                Format in Json: <Checkbox checked={format} onChange={() => setFormat(!format)} />
                                            </span>
                                        </MDTypography>
                                    </th>
                                </tr>
                                {format && (
                                    <tr>
                                        <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
                                            <MDButton variant="gradient" color="dark" size="small" onClick={() => setExpand(!expand)}>
                                                {expand ? "Collapse All" : "Expand All"}
                                            </MDButton>
                                        </th>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="jsontree" style={{ backgroundColor: darkMode ? "#1a2035" : "#fff" }}>
                    {format ? (
                        <JSONTree
                            data={paramTableData}
                            theme={JSONTreeTheme}
                            invertTheme={true}
                            shouldExpandNodeInitially={() => expand}
                            labelRenderer={([key]) => <span style={{ fontSize: "1rem" }}>{key}</span>}
                            valueRenderer={(raw) => <span style={{ fontSize: "1rem" }}>{raw}</span>}
                            hideRoot={!expand}
                        />
                    ) : (
                        <pre style={{ color: darkMode ? "#fff" : "#000" }}>{JSON.stringify(paramTableData, null, 2)}</pre>
                    )}
                </div>
            </MDModal>
            <Footer />
        </DashboardLayout>
    );
}

export default RivioWebHookManagement;

